import React from "react";
import EditBodyHashLink from "./EditBodyHashLink";
import EditBodyProgress from "./EditBodyProgress";
import style from "../../style/EditBodySidebar.module.scss";

function EditBodySidebar({ progressData, rowId, CaseStatus, PatientStatus, hospital, caseCode, referralFeedback }) {
  return (
    <div className={style.container}>
      <EditBodyHashLink rowId={rowId} />
      <EditBodyProgress
        progressData={progressData}
        CaseStatus={CaseStatus}
        PatientStatus={PatientStatus}
        rowId={rowId}
        hospital={hospital}
        caseCode={caseCode}
        referralFeedback={referralFeedback}
      />
    </div>
  );
}

export default EditBodySidebar;
